import { CONNECT_MODAL } from '../constants';
import { setActiveModal } from './modals';

export const ADD_STEP_TO_STACK = 'ADD_STEP_TO_STACK';
export const REMOVE_STEP_FROM_STACK = 'REMOVE_STEP_FROM_STACK';
export const RESET_CONNECT_FLOW = 'RESET_CONNECT_FLOW';

export const addStepToStack = modalType => {
  return { type: ADD_STEP_TO_STACK, payload: modalType };
};

export const removeStepFromStack = () => {
  return { type: REMOVE_STEP_FROM_STACK };
};

export const openConnectModal = () => {
  return dispatch => {
    dispatch(setActiveModal(CONNECT_MODAL, {}));
    dispatch(addStepToStack(CONNECT_MODAL));
  };
};

export const setActiveConnectModal = modalType => {
  return (dispatch, getState) => {
    if (getState().modals.activeModal === CONNECT_MODAL) {
      dispatch(addStepToStack(modalType));
      return;
    }

    dispatch(setActiveModal(modalType, {}));
  };
};

export const resetConnectFlow = () => {
  return { type: RESET_CONNECT_FLOW };
};

export const connectFlowInitialState = null;

const push = (state, next) => {
  return {
    value: next,
    prev: state
  };
};

const pop = state => {
  return state === null ? state : state.prev;
};

export default function connectFlow(state = connectFlowInitialState, action) {
  switch (action.type) {
    case ADD_STEP_TO_STACK: {
      return push(state, action.payload);
    }
    case REMOVE_STEP_FROM_STACK:
      return pop(state);
    case RESET_CONNECT_FLOW:
      return connectFlowInitialState;
    default:
      return state;
  }
}
